import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/noDataOrder.png'


const _withScopeId = n => (_pushScopeId("data-v-07d2ed9d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "orderBox"
}
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "high" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "org" }
const _hoisted_6 = { style: {"font-size":"0.26rem"} }
const _hoisted_7 = ["textContent"]
const _hoisted_8 = { class: "end" }
const _hoisted_9 = ["textContent"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "r" }, null, -1))
const _hoisted_11 = {
  key: 2,
  class: "noDataOrder"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_13 = { class: "paging" }

import { reactive, ref, watch, computed } from "vue";
import { toRaw } from "@vue/reactivity";
import { queryBillLists } from "@/api/userCenter";
import { Search } from "@element-plus/icons-vue";
import i18n from "@/lang";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'ItemBill',
  setup(__props) {

const store = useStore();
const isMobile = computed(() => !!store.state.isMobile);

const billMation = reactive({
  total: 0,
  list: [],
});
const pageInfo = reactive({
  pageSize: 10,
  pageIndex: 1,
});
const queryParams = reactive({
  // 赠送人/受赠人
  content: undefined,
  // 服务时间
  startTime: undefined,
  endTime: undefined,
  // 余额变动
  direction: undefined,
  // 服务类型
  tradeType: undefined,
});
const isShowTimer = ref(false);
const dateSearch = ref("");
const keywordSearchFn = () => {
  handlerPage();
};
watch(
  () => dateSearch.value,
  () => {
    let dates = toRaw(dateSearch.value || []);
    queryParams.startTime = dates[0] || undefined;
    queryParams.endTime = dates[1] || undefined;
  }
);
const options_balance = reactive([
  {
    value: undefined,
    label: "information.searchType.all",
  },
  {
    value: 1,
    label: "information.searchType.increase",
  },
  {
    value: 0,
    label: "information.searchType.diminished",
  },
]);
const options_type = reactive([
  {
    value: undefined,
    label: "information.searchType.all",
  },
  {
    value: "consume",
    label: "information.searchType.consume",
  },
  {
    value: "recharge",
    label: "information.searchType.recharge",
  },
  {
    value: "active",
    label: "information.searchType.active",
  },
  {
    value: "give",
    label: "information.searchType.give",
  },
  {
    value: "receive",
    label: "information.searchType.receive",
  },
  {
    value: "auto_deduct",
    label: "information.searchType.auto_deduct",
  },
  {
    value: "change",
    label: "information.searchType.change",
  },
]);
const contentList = (row: any) => {
  const $t = i18n.global.t;
  let content = "";
  if (row.tradeType == "consume") {
    content =
      $t("information.serviceContent.consume.before") +
      " " +
      row.content +
      " " +
      $t("information.serviceContent.consume.after");
    return content;
  }
  if (row.tradeType == "recharge") {
    content =
      $t("information.serviceContent.recharge.before") +
      " " +
      row.subAmount +
      " " +
      $t("information.serviceContent.recharge.after");
    return content;
  }
  if (row.tradeType == "active") {
    content =
      $t("information.serviceContent.active.before") +
      " " +
      row.content +
      " " +
      $t("information.serviceContent.active.after");
    return content;
  }
  if (row.tradeType == "give") {
    content =
      $t("information.serviceContent.give.before") +
      " " +
      row.content +
      " " +
      row.subAmount +
      " " +
      $t("information.serviceContent.give.after");
    return content;
  }
  if (row.tradeType == "receive") {
    content =
      row.content +
      " " +
      $t("information.serviceContent.receive.before") +
      " " +
      row.subAmount +
      " " +
      $t("information.serviceContent.receive.after");
    return content;
  }
  if (row.tradeType == "auto_deduct") {
    content =
      $t("information.serviceContent.auto_deduct.before") +
      " " +
      row.subAmount +
      " " +
      $t("information.serviceContent.auto_deduct.after");
    return content;
  }
  if (row.tradeType == "change") {
    content =
      $t("information.serviceContent.change.before") +
      " " +
      row.subAmount +
      " " +
      $t("information.serviceContent.change.after");
    return content;
  }
};
const handlerPage = () => {
  queryBillLists({
    ...pageInfo,
    ...queryParams,
  }).then((res) => {
    billMation.total = res.data.total;
    billMation.list = res.data.records;
  });
};
handlerPage();

return (_ctx: any,_cache: any) => {
  const _component_SecondPageHeader = _resolveComponent("SecondPageHeader")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isMobile))
      ? (_openBlock(), _createBlock(_component_SecondPageHeader, {
          key: 0,
          title: _ctx.$t('user_center.account_list'),
          toPath: "/userCenter"
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(['orderList', { mobileSize: _unref(isMobile) }])
    }, [
      (!_unref(isMobile))
        ? (_openBlock(), _createBlock(_component_el_form, {
            key: 0,
            "label-position": "top",
            class: "mainForm"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, { gutter: 20 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, {
                    span: 10,
                    xs: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('information.bill.createTime')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: dateSearch.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dateSearch).value = $event)),
                            type: "datetimerange",
                            "range-separator": "-",
                            "start-placeholder": _ctx.$t('information.searchTime.startTime'),
                            "end-placeholder": _ctx.$t('information.searchTime.endTime'),
                            format: "YYYY/MM/DD hh:mm:ss",
                            "value-format": "YYYY/MM/DD hh:mm:ss",
                            onChange: _cache[1] || (_cache[1] = ($event: any) => (keywordSearchFn()))
                          }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 4,
                    xs: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('information.bill.tradeType')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: queryParams.tradeType,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryParams.tradeType) = $event)),
                            onChange: _cache[3] || (_cache[3] = ($event: any) => (keywordSearchFn())),
                            placeholder: "Select"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options_type, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: _ctx.$t(item.label),
                                  value: item.value,
                                  "popper-append-to-body": "true"
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 4,
                    xs: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('information.bill.change')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: queryParams.direction,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((queryParams.direction) = $event)),
                            onChange: _cache[5] || (_cache[5] = ($event: any) => (keywordSearchFn())),
                            placeholder: "Select"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options_balance, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: _ctx.$t(item.label),
                                  value: item.value,
                                  "popper-append-to-body": "true"
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 6,
                    xs: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('information.bill.keyword')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: queryParams.content,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((queryParams.content) = $event)),
                            placeholder: _ctx.$t('information.keyword')
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                icon: _unref(Search),
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (keywordSearchFn()))
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (billMation.total != 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (!_unref(isMobile))
              ? (_openBlock(), _createBlock(_component_el_table, {
                  key: 0,
                  data: billMation.list,
                  style: {"width":"100%"},
                  stripe: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      prop: "subHistorySerialNo",
                      label: _ctx.$t('information.bill.subHistorySerialNo'),
                      align: "center",
                      "show-overflow-tooltip": "",
                      width: "188"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _ctx.$t('information.bill.createTime'),
                      align: "center",
                      width: "170",
                      prop: "createTime"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _ctx.$t('information.bill.tradeType'),
                      align: "center",
                      width: "140"
                    }, {
                      default: _withCtx((scope) => [
                        _createTextVNode(_toDisplayString(_ctx.$t(`information.searchType.${scope.row.tradeType}`)), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _ctx.$t('information.bill.content'),
                      align: "center",
                      width: "170"
                    }, {
                      default: _withCtx((scope) => [
                        _createTextVNode(_toDisplayString(contentList(scope.row)), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: _ctx.$t('information.bill.change'),
                      align: "center"
                    }, {
                      default: _withCtx((scope) => [
                        _createTextVNode(_toDisplayString(scope.row.direction == 1
                ? "+" + scope.row.subAmount
                : "-" + scope.row.subAmount) + "  " + _toDisplayString(_ctx.$t("information.device_months")), 1)
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["data"]))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(billMation.list, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "cardBox",
                    key: index
                  }, [
                    _createElementVNode("div", {
                      class: "title",
                      textContent: _toDisplayString(_ctx.$t(`information.searchType.${item.tradeType}`))
                    }, null, 8, _hoisted_2),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", {
                        class: "gray",
                        textContent: _toDisplayString(contentList(item))
                      }, null, 8, _hoisted_4),
                      _createElementVNode("div", _hoisted_5, [
                        _createTextVNode(_toDisplayString(item.direction == 1 ? "+" + item.subAmount : "-" + item.subAmount), 1),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("information.device_months")), 1)
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: "sub",
                      textContent: _toDisplayString(item.subHistorySerialNo)
                    }, null, 8, _hoisted_7),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", {
                        class: "l",
                        textContent: _toDisplayString(item.createTime)
                      }, null, 8, _hoisted_9),
                      _hoisted_10
                    ])
                  ]))
                }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("information.not_bill_info")), 1)
          ])),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_el_pagination, {
          background: "",
          layout: "prev, pager, next",
          onSizeChange: handlerPage,
          onCurrentChange: handlerPage,
          "current-page": pageInfo.pageIndex,
          "onUpdate:current-page": _cache[8] || (_cache[8] = ($event: any) => ((pageInfo.pageIndex) = $event)),
          "hide-on-single-page": "",
          "page-size": pageInfo.pageSize,
          "onUpdate:page-size": _cache[9] || (_cache[9] = ($event: any) => ((pageInfo.pageSize) = $event)),
          total: billMation.total
        }, null, 8, ["current-page", "page-size", "total"])
      ])
    ], 2)
  ], 64))
}
}

})